/*
* Created on Jan 08, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {SUPPORTED_LANGUAGES} from "../../service/common";
import {useTranslation} from "react-i18next";
import {useRegion} from "../../context/RegionContext";

const HeaderUtilLangComponent = ({switchLang, dialog, node, subMenu}) => {
    const {i18n} =  useTranslation();
    const {region} = useRegion();

    const setLang = (lang) => {
        if (region === 'CHINA' && lang.value !== 'zh' && window._env_.REACT_APP_STRICT_CHINA_REGION) {
            dialog(true);
            switchLang(lang.value)
        }
        else{
            i18n.changeLanguage(lang.value);
            window.localStorage.setItem('userLang', lang.value);
            setGlobalJPCSS(lang.value)
        }
    }

    const convert_locale = () => {
        if (i18n.language) {
            setGlobalJPCSS(i18n.language)
            const locale = i18n.language?.split('-');
            if (locale.length > 1 && locale[1] === 'TW') {
                return i18n.language
                // setSelectLang(i18n.language);
            }
            else {
                return locale[0];
                // setSelectLang(locale[0]);
            }
        }
        else {
            return ''
            // setSelectLang('');
        }
    }

    const setGlobalJPCSS = (lang) => {
        if (lang === 'ja') {
            document.querySelectorAll('body')[0].className = 'ff-jp';
            document.documentElement.setAttribute("lang", 'ja');
        }
        else if (lang === 'zh') {
            document.querySelectorAll('body')[0].className = 'ff-cn';
            document.documentElement.setAttribute("lang", 'zh-CN');
        }
        else {
            document.querySelectorAll('body')[0].className = 'ff-global';
            if (lang === 'zh_TW') {
                document.documentElement.setAttribute("lang", 'zh-TW');
            }
            else {
                document.documentElement.setAttribute("lang", 'en');
            }
        }
    }


    return (
        <>
            <ul className={subMenu === 'language' ? '' : 'hide'} ref={node}>
                <li className="section">
                {
                    i18n?.language && SUPPORTED_LANGUAGES && SUPPORTED_LANGUAGES.map((l, index)=> {
                                                                                 const select = convert_locale();
                                                                                 return (<div
                                                                                         className={`section-items selection ${select === l.value ? 'selected' : ''}`}
                                                                                         key={`lang-${index}`} onClick={() => setLang(l)}>{l.name}</div>)
                                                                                 })
                }
                </li>
            </ul>
        </>
    );
};

export default HeaderUtilLangComponent;